<template>
    <div class="p-3">
        <b-alert show variant="danger">{{ $t("message.notAuthorizedToDisplayPage") }}</b-alert>
    </div>
</template>

<script>
export default {
    name: "PermissionDenided",
};
</script>

<style scoped></style>
